const hideField = (field, fields, updateFields) => {
    if( field === undefined ) {
        return true
    }

    if( field.hasOwnProperty('dependency') ) {
        const dependencyField = field.dependency.depends_on_column
        // calculated fields don't have a databaseFieldName presented
        const dependencyRecord = fields.columns.find( record => record !== undefined && record.fullDatabaseFieldName === dependencyField)

        // the field I depend on doesn't exist
        if( dependencyRecord === undefined ) {
            return true
        }

        if( field.dependency.depends_on_not_null ) {
            const dependencyValue = dependencyRecord.value === 'Yes' ? true : dependencyRecord.value
            let updateValue
            if( updateFields.hasOwnProperty(dependencyField) ) {
                if( dependencyRecord.hasOwnProperty('options') ) {
                    const optionValue = dependencyRecord.options.find(option => option.value === updateFields[dependencyField].value).label
            
                    updateValue = optionValue === 'Yes' ? true : updateValue
                } else {
                    updateValue = updateFields[dependencyField].value === 'Yes' ? true : updateFields[dependencyField].value
                }
            } else {
                updateValue = undefined
            }

            if( (updateFields[dependencyField] === undefined && dependencyValue === null) || 
				dependencyValue === undefined ||  
				dependencyValue === '' ||
                (updateFields[dependencyField] !== undefined && updateValue === undefined)) {
                return true
            }
        }


        if( field.dependency.hasOwnProperty('depends_on_value') ) {
            const dependencyValue = dependencyRecord.value === 'Yes' ? true : dependencyRecord.value

            let updateValue
            if( updateFields.hasOwnProperty(dependencyField) ) {
                if( dependencyRecord.hasOwnProperty('options') ) {
                    if( Array.isArray(updateFields[dependencyField].value) ) {
                        updateValue = updateFields[dependencyField].value.map(updateVal => dependencyRecord.options.find(option => option.value === updateVal).label)
                   } else {
					   let optionValue
					   if( updateFields[dependencyField].value.hasOwnProperty('value') ) {
                        optionValue = dependencyRecord.options.find(option => option.value === updateFields[dependencyField].value.value).label
					   } else {
                        optionValue = dependencyRecord.options.find(option => option.value === updateFields[dependencyField].value).label
					   }

                       updateValue = optionValue === 'Yes' ? true : optionValue
                    }
                } else {
                    updateValue = updateFields[dependencyField].value === 'Yes' ? true : updateFields[dependencyField].value
                }
            } else {
                updateValue = undefined
            }

            if( (!updateFields.hasOwnProperty(dependencyField) &&
                !Array.isArray(dependencyValue) && dependencyValue !== field.dependency.depends_on_value) ||
                (!updateFields.hasOwnProperty(dependencyField) &&
                Array.isArray(dependencyValue) && !dependencyValue.includes(field.dependency.depends_on_value)) ||
                ( !Array.isArray(updateValue) && updateFields.hasOwnProperty(dependencyField) &&
                  updateValue !== field.dependency.depends_on_value ) ||
                ( Array.isArray(updateValue) && updateFields.hasOwnProperty(dependencyField) &&
                  !updateValue.includes(field.dependency.depends_on_value) )) {
                return true
            }
        }
    }

    return false
}

const isProvider = (user) => {
	return (user && user.role_objects.find((element:any) => element.value === 'Attending') !== undefined)
}

const handleCallback = async (msalInstance: any, createRedcapEntry:(value: any) => void, setAuthUser:(value: any) => void) => {
    try {
        const response = await msalInstance.handleRedirectPromise();
        if (response) {
            const destination = response.state || sessionStorage.getItem('post-login-redirect-url') || '/';
      // Redirect the user to the intended page
            sessionStorage.removeItem('post-login-redirect-url'); // Clean up
			msalInstance.setActiveAccount(response.account)

			if( response.state && response.state === `${window.location.origin}/registered`) {
				await createRedcapEntry(response)
			}
			setAuthUser(response)
			localStorage.setItem('authUser', JSON.stringify(response))
            window.location.href = destination;
        }
    } catch (error) {
        console.error(error);
    }
}

export {
  hideField,
  isProvider,
  handleCallback,
};

